import { render, staticRenderFns } from "./ModalPostWindow.vue?vue&type=template&id=3c4ae380&"
import script from "./ModalPostWindow.vue?vue&type=script&lang=js&"
export * from "./ModalPostWindow.vue?vue&type=script&lang=js&"
import style0 from "./ModalPostWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports